import { action, observable, runInAction } from "mobx";
import moment from "moment";
import AgencyService from "services/AgencyService";
import ReportTemplateService from "services/TemplateGroup/ReportTemplateService";
import UserService from "services/UserService";
import { DATE_FORMAT, INTERSECTION_SCOPE, MANUAL_SCOPE, RESOURCE_LIST, SYSTEM_ROUTES_PATH, } from "utils/constants";
import BaseStore from "../BaseStore";

const DEFAULT_TEMPLATE_FORM = {
  id: null,
  name: null,
  description: null,
  week_days: [
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
  ],
  agency_id: null,
  time_zone: "Z",
  start_time: null,
  end_time: null,
  aggregation: "HOURLY",
  date_range: {
    scope: "RELATIVE",
    start_date: null,
    end_date: null,
    unit: "DAY",
    offset: null,
  },
  intersection: {
    scope: "SPECIFIC_INTERSECTION",
    uuids: [],
  },
  schedule: {
    metric_settings: [],
    recordSelected: [],
    scope: "MANUAL",
    value: {
      date: moment().format(DATE_FORMAT.day_only_backend),
      offset: 1,
      day_of_week: [
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
        "SUNDAY",
      ],
      day_of_month: ["1"],
    },
    time: null,
  },
};

class ReportTemplateStoreStore extends BaseStore {
  constructor(parentStore) {
    super(new ReportTemplateService(parentStore), parentStore);
    this.filterData = {
      ...this.filterData,
      ...{
        text: "",
        aggregation: null,
        agency_id: "",
        from_date: null,
        to_date: null,
        owner_id: null,
        status: null,
        sort: "",
      },
    };
    this.currentModuleRoute = SYSTEM_ROUTES_PATH.ReportTemplate;
    this.resourceName = RESOURCE_LIST.REPORT_TEMPLATE;
  }

  isEditFormDirty = false; // make sure formData is not be edited
  @observable context_id = null;
  @observable allIntersections = [];
  @observable allAgencies = [];
  @observable allUsers = [];
  @observable currentTab = "1";
  @observable formData = {
    ...DEFAULT_TEMPLATE_FORM,
  };
  @observable selectedRecordRowSchedule = [];
  @observable isSelectedReccuring = false;
  @observable timeValueSelectedOccuring = MANUAL_SCOPE;

  DEFAULT_METRIC_SETTING = [];

  @action setTemplateId = (id) => {
    this.context_id = id;
  };

  @action resetForm() {
    this.context_id = null;
    this.formData = {
      ...DEFAULT_TEMPLATE_FORM,
    };
  }

  @action setFormField = (field, value) => {
    this.isEditFormDirty = true;
    const fieldTree = field.split(".");
    switch (fieldTree.length) {
      case 1: {
        this.formData[field] = value;
      }
        break;
      case 2: {
        this.formData[fieldTree[0]][fieldTree[1]] = value;
      }
        break;
      case 3: {
        this.formData[fieldTree[0]][fieldTree[1]][fieldTree[2]] = value;
      }
        break;
    }
  };
  @action setOccuringTime = () => {
    this.isSelectedReccuring = true;
  };
  @action setTimeValueSelectedOccuring = (value) => {
    this.timeValueSelectedOccuring = value;
  };
  @action getAllUsers = (agency_id) => {
    const userService = new UserService(this.parentStore);
    if (this.allUsers?.length === 0) {
      this.loading = true;
      userService?.getAllUserByAgency(
        agency_id,
        (response) => {
          runInAction(() => {
            this.allUsers = response?.data;
          });
        },
        () => {
          runInAction(() => {
            this.loading = false;
          });
        }
      );
    }
  };
  @action getAllAgencies = (cb) => {
    const agencyService = new AgencyService(this.parentStore);
    agencyService.getAll((data) => {
      runInAction(() => {
        this.allAgencies = data;
        if (!this.formData?.agency_id) this.formData.agency_id = data[0]?.id;
        cb && cb();
      });
    });
  };

  @action runTemplate = (id, cb) => {
    this.moduleService.runTemplate(
      id,
      () => {
        runInAction(() => {
          cb && cb();
        });
      },
      () => {
      }
    );
  };
  @action setDetaultAgencyFilter = (isSuperAdmin, cb) => {
    const agencyService = new AgencyService(this.parentStore);
    if (isSuperAdmin)
      agencyService.getAll((data) => {
        runInAction(() => {
          this.allAgencies = data;
          //set default agency
          if (Array.isArray(this.allAgencies) && this.allAgencies[0]) {
            let defaultAgency = this.allAgencies.find(
              (item) => item.id === this.filterData.agency_id
            );
            if (!defaultAgency) {
              this.filterData.agency_id = this.allAgencies[0].id;
            }
          }
          cb && cb();
        });
      });
    else {
      const currentAgency = this.parentStore.myStore.currentAgency;
      this.filterData = {
        ...this.filterData,
        ...{ agency_id: currentAgency.agency_id },
      };
      cb && cb();
    }
  };

  @action getTemplatePopupTrend = (cb) => {
    this.moduleService?.getDetailPopupTrend((data) => {
      runInAction(() => {
        this.DEFAULT_METRIC_SETTING = data?.metrics;
        this.formData.schedule.metric_settings = this.DEFAULT_METRIC_SETTING;
      });
      cb && cb();
    });
  };
  @action setNewRecordSelectScheduleTab = (action) => {
    this.formData.schedule.recordSelected = action;
  };
  @action getTemplateDetail = (id, cb) => {
    this.isEditFormDirty = false;
    this.moduleService?.getDetail(id, (response) => {
      runInAction(() => {
        this.formData = {
          ...DEFAULT_TEMPLATE_FORM,
          ...response,
          date_range: {
            ...DEFAULT_TEMPLATE_FORM.date_range,
            ...response.date_range,
          },
        };
      });
      this.moduleService.getScheduleDetail(id, (response) => {
        const recordSelectedData = response.metric_settings?.filter(
          (e) => e.enabled === true
        );
        runInAction(() => {
          this.formData.schedule = {
            ...DEFAULT_TEMPLATE_FORM.schedule,
            ...response,
            value: {
              ...DEFAULT_TEMPLATE_FORM.schedule.value,
              ...response?.value,
            },
            metric_settings: response.metric_settings
              ? response.metric_settings
              : this.DEFAULT_METRIC_SETTING,
            recordSelected: recordSelectedData?.map((e) => e.key_name),
          };
          this.selectedRecordRowSchedule = response.metric_settings?.filter(
            (e) => e.enabled === true
          );
          cb && cb();
        });
      });
    });
  };

  @action changeReportTemplateTab = (tab) => {
    this.currentTab = tab;
  };
  @action setIntersectionList = (scope, ids) => {
    if (scope === INTERSECTION_SCOPE.SPECIFIC) {
      this.formData.intersection = {
        scope: scope,
        uuids: ids.map((e) => e?.id),
      };
    } else
      this.formData.intersection = {
        scope: scope,
        uuids: "*",
      };
  };
  @action submitUpdateSchedule = (cb, fb) => {
    this.moduleService?.updateSchedule(
      {
        id: this.formData.id,
        data: this.formData.schedule,
      },
      (id) => {
        // helper.showNotification(NOTIFICATION_TYPE.SUCCESS, i18n.t("success"), i18n.t("update_success"))
        cb && cb(id);
      },
      (error) => {
        runInAction(() => {
          fb && fb(error?.errors);
          this.loading = false;
        });
      }
    );
  };
  @action submitUpdateTemplate = (cb, fb) => {
    this.moduleService?.update(
      this.formData,
      (id) => {
        // helper.showNotification(NOTIFICATION_TYPE.SUCCESS, i18n.t("success"), i18n.t("update_success"))
        cb && cb(id);
      },
      (error) => {
        runInAction(() => {
          fb && fb(error?.errors);
          this.loading = false;
        });
      }
    );
  };
  @action submit = (cb, fb) => {
    this.loading = true;
    this.moduleService?.create(
      this.formData,
      () => {
        cb && cb();
      },
      (error) => {
        runInAction(() => {
          fb && fb(error?.errors);
          this.loading = false;
        });
      }
    );
  };
  @action setStatus = (data = null, status) => {
    this.loading = true;
    if (!data) {
      data = this.selectedItems;
    }
    this.moduleService?.updateStatus(
      "/activate",
      { template_ids: data, status },
      () => {
        this.getData();
      },
      () => {
        runInAction(() => {
          this.loading = false;
        });
      }
    );
  };
  @action delete = (data = null) => {
    this.loading = true;
    if (!data) {
      data = this.selectedItems;
    }
    this.moduleService?.delete(
      data,
      () => {
        //redirect into page 1 avoid load wrong data
        this.filterData.pagination.current = 1;
        this.getData();
      },
      () => {
        runInAction(() => {
          this.loading = false;
        });
      }
    );
  };
}

export default ReportTemplateStoreStore;
